module.exports = __webpack_public_path__ + "fd2c8ce3854cdbfb3448fda0c0e27a86.png";